import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=485e06b4&"
import script from "./ShippingInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInfo.vue?vue&type=style&index=0&id=485e06b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports